import React from 'react'
import { Helmet } from 'react-helmet'
import logo from './logo.svg';
import './App.css';

const TITLE = 'NC Validator Dev'

function App() {
  return (
    <div className="App">
        <Helmet>
          <title>{ TITLE }</title>
        </Helmet>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Welcome!
        </p>
   
      </header>
    </div>
  );
}

export default App;
